export default __webpack_public_path__ + "static/media/Mneskin.f7bb873f.mp3";